import { RoleType } from '../interfaces/RoleType.enum';

export const sequenceProjectAnalysisProhibitedRoles: RoleType[] = [
	RoleType.VIEWER,
	RoleType.MANAGER,
	RoleType.EXECUTIVE,
];
